export default __webpack_public_path__ + "static/media/226.45d1a634.gif";